/* Core & libraries */
import React from 'react';
import { useTheme } from 'react-jss';
import moment from 'helpers/moment';
import { Accordion } from "react-bootstrap";

/* Helpers, constants, custom methods, internal libraries */
import { FormattedMessage } from 'react-intl';
import { ReactComponent as WarningSign } from "../../../resources/images/alert-triangle.svg"
import { ReactComponent as Lock } from "../../../resources/images/lock-01.svg"

/* Components */
/* Styles */
import styles from './styles.js';

const OPTION_VALUE_MAP = {
  TRUE: 'TRUE',
  FALSE: 'FALSE',
  PERSONAL: 'PERSONAL',
}

const Content = ({
  settingsPreferences,
  setSettingsPreferences,
  settingsLocked,
  optionsResponse,
  tripCreditsOptionsText
}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const handleSettingsChoice = (creditSetting) => {
    setSettingsPreferences(prev => ({
      ...prev,
      currentTripCreditAutoAssignmentType: creditSetting,
    }));
  };

  const availableKeys = optionsResponse[0]?.options?.map(
    option => OPTION_VALUE_MAP[option.optionValue]
  )

  const filteredTripCreditsSettings = tripCreditsOptionsText?.filter(setting =>
    availableKeys.includes(setting.key)
  )

  const selectedOption = settingsPreferences?.currentTripCreditAutoAssignmentType.toUpperCase();
  const lastUpdatedFormattedDate = moment(settingsPreferences?.lastTripCreditAssignmentTime?.substring(0, 23)).format('MM/DD/YYYY [at] h:mm A');
  const remainingLockedFormattedTime = moment(settingsPreferences?.remainingTimeForTripCreditAssignment, "HH:mm").format("HH[h] mm[m]");

  const getOptionClass = (key) => [
    classes.optionContainer,
    selectedOption === OPTION_VALUE_MAP[key] && classes.selectedOptionContainer,
    settingsLocked && selectedOption === OPTION_VALUE_MAP[key] && classes.lockedOptionSelectedContainer,
    settingsLocked && selectedOption !== OPTION_VALUE_MAP[key] && classes.lockedOptionContainer,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes.modalContent}>
      {settingsLocked ? (
        <div className={classes.updatesNotificationBanner}>
          <div className={classes.descriptionDiv}>
            <div className={classes.lockSvg}><Lock /></div>
            <div>
              <p className={classes.warningTitle}><FormattedMessage id={"tripCredits.settings.modal.locked"} /></p>
              <p className={classes.warningDescription}><FormattedMessage id={"tripCredits.settings.modal.locked.description"} values={{lockedFor : remainingLockedFormattedTime}}/></p>
              {settingsPreferences?.tripCreditsAssignmentsChangedBy && (
                <p className={classes.warningDescription}>
                  <FormattedMessage
                    id={'tripCredits.settings.modal.updates.description'}
                    values={{
                      lastUpdatedDate: lastUpdatedFormattedDate,
                      changedBy: settingsPreferences?.tripCreditsAssignmentsChangedBy,
                    }}
                  />
                </p>
              )}            </div>
          </div>
        </div>
      ) : (
        <>
          {settingsPreferences?.tripCreditsAssignmentsChangedBy && settingsPreferences?.lastTripCreditAssignmentTime && (
            <div className={classes.updatesNotificationBanner}>
              <div className={classes.descriptionDiv}>
                <div className={classes.warningSvg}><WarningSign /></div>
                <div className={classes.textContainer}>
                  {settingsPreferences?.tripCreditAssignmentTimeInterval !== '0' && (
                    <p className={classes.warningTitle}>
                      <FormattedMessage
                        id={'tripCredits.settings.modal.updates.limited'}
                        values={{ limitedForTime: settingsPreferences?.tripCreditAssignmentTimeInterval }}
                      />
                    </p>
                  )}
                  <p className={classes.warningDescription}>
                    <FormattedMessage
                      id={'tripCredits.settings.modal.updates.description'}
                      values={{
                        lastUpdatedDate: lastUpdatedFormattedDate,
                        changedBy: settingsPreferences?.tripCreditsAssignmentsChangedBy,
                      }}
                    />
                  </p>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      

      <Accordion alwaysOpen defaultActiveKey={[String(filteredTripCreditsSettings.findIndex(({ key }) => selectedOption === OPTION_VALUE_MAP[key.toUpperCase()]))]} className={classes.accordion}>
        {filteredTripCreditsSettings.map(({ key, titleId, descriptionId }, i) => (
          <React.Fragment key={key}>
            <div
              className={getOptionClass(key.toUpperCase())}
              onClick={() => !settingsLocked && handleSettingsChoice(key)}
            >
              <Accordion.Item eventKey={String(i)} className={[classes.accordionItem, !settingsLocked && selectedOption === OPTION_VALUE_MAP[key.toUpperCase()] && classes.selectedAccordionItem].filter(Boolean).join(' ')}>
                <Accordion.Header onClick={e => e.stopPropagation()}>
                  <div className={classes.titleContainer}>
                    <FormattedMessage id={titleId} />
                  </div>
                  <input
                    onChange={() => handleSettingsChoice(key)}
                    type="radio"
                    name={key}
                    id={key}
                    checked={selectedOption === OPTION_VALUE_MAP[key.toUpperCase()]}
                    disabled={settingsLocked}
                    onClick={e => e.stopPropagation()}
                  />
                </Accordion.Header>
                <Accordion.Body onClick={e => e.stopPropagation()}>
                  <p><FormattedMessage id={descriptionId} /></p>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            {i !== filteredTripCreditsSettings.length - 1 && <hr className={classes.divider} />}
          </React.Fragment>
        ))}
      </Accordion>
    </div>
  );
};

export default Content;